const defaults = {
  breakpoint: null,
  toggleIcon: null,
  singular: null,
  group: null,
};

type Config = {
  toggleIcon?: null | string,
  breakpoint?: null | number,
  singular?: null | boolean,
  group?: null | string,
};
class Accordion {
  header:HTMLElement;

  content:HTMLElement;

  icon:HTMLElement;

  breakpoint:number;

  singular: boolean;

  group: string;

  active:boolean;

  public container: HTMLElement;

  public config: Config;

  constructor(
    container:HTMLElement,
    config:Config,
  ) {
    this.container = container;
    this.config = config;

    this.header = container.querySelector('.accordion--header');
    this.content = container.querySelector('.accordion--content');
    this.icon = this.config.toggleIcon ? container.querySelector(config.toggleIcon) : null;
    this.breakpoint = this.config.breakpoint ? config.breakpoint : null;
    this.group = this.config.group;
    this.singular = this.config.singular;
    this.active = false;
    this.init();
  }

  bindEventListeners() {
    this.header.addEventListener('click', () => {
      if (this.breakpoint != null) {
        this.handleBreakpoint();
      } else {
        this.toggle();
      }
    });

    if (this.singular) {
      document.addEventListener('accordions:close', (e:CustomEvent) => {
        const { group } = e.detail;
        if (this.group === group && this !== e.detail.parent) {
          this.close();
        }
      });
    }
  }

  recalculateMaxHeight() {
    if (this.content.style.maxHeight) {
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
    }
  }

  toggle() {
    this.active = !this.active;

    if (this.content.style.maxHeight) {
      this.icon?.classList.remove('accordion__icon--active');
      this.header.classList.remove('accordion--header--active');
      this.content.setAttribute('aria-hidden', 'true');
      this.content.style.maxHeight = null;
    } else {
      this.icon?.classList.add('accordion__icon--active');
      this.header.classList.add('accordion--header--active');
      this.content.setAttribute('aria-hidden', 'false');
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
      if (this.singular) {
        document.dispatchEvent(new CustomEvent('accordions:close', { detail: { group: this.group, parent: this } }));
      }
    }
  }

  open() {
    this.icon?.classList.add('accordion__icon--active');
    this.content.setAttribute('aria-hidden', 'false');
    this.content.style.maxHeight = `${this.content.scrollHeight}px`;

    if (this.singular) {
      document.dispatchEvent(new CustomEvent('accordions:close', { detail: { group: this.group, parent: this } }));
    }
  }

  close() {
    this.icon?.classList.remove('accordion__icon--active');
    this.header.classList.remove('accordion--header--active');
    this.content.setAttribute('aria-hidden', 'true');
    this.content.style.maxHeight = null;
  }

  handleBreakpoint() {
    if (window.innerWidth <= this.breakpoint) {
      this.close();
    } else {
      this.open();
    }

    this.header.addEventListener('click', () => {
      if (window.innerWidth <= this.breakpoint) this.toggle();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > this.breakpoint) {
        this.open();
      } else if (!this.active) {
        this.close();
      }
    });
  }

  init() {
    if (this.breakpoint != null) {
      this.handleBreakpoint();
    } else {
      this.bindEventListeners();
    }

    this.recalculateMaxHeight();
  }
}

export default (el:HTMLElement, config:Config) => new Accordion(el, { ...defaults, ...config });
